module.exports = __webpack_public_path__ + "img/Facilitator test Learning Lab - SWAHILI.edc822d5.png";